import React from 'react';
import { Smartphone } from 'lucide-react';
import SettingsShell from './SettingsShell';
import LegalFooter from '../../components/LegalFooter';
import InstallApp from '../../components/InstallApp';

const SUPPORT_EMAIL = 'support@leadmarka.co.zw';

const AboutSettings = () => {
  return (
    <SettingsShell
      title="About & Legal"
      description="App details, support, and legal policies."
    >
      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <h3 className="font-medium text-gray-900 mb-3">About</h3>
        <div className="space-y-2 text-sm text-gray-600">
          <p><strong>LeadMarka</strong> - WhatsApp CRM</p>
          <p>Version: MVP v1.0</p>
          <p>Never forget a WhatsApp lead again.</p>
          <p>
            Support:{' '}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>
        <LegalFooter className="mt-4" />
      </div>

      <div className="bg-white rounded-lg p-4 border border-gray-200">
        <h3 className="font-medium text-gray-900 mb-3 flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-gray-400" />
          App
        </h3>

        <InstallApp showStatus />
      </div>
    </SettingsShell>
  );
};

export default AboutSettings;
